// extracted by mini-css-extract-plugin
export default {"container":"IK-z","timeTop":"JK-z","timeCountdown":"KK-z","cta":"LK-z","disabled":"MK-z","product":"NK-z"};